import { writable } from 'svelte/store';
import { db } from './idb';
export const trackersStore = function () {
    const { subscribe, set, update } = writable([]);
    async function loadTrackers() {
        const trackerIds = await (await db).getAllKeys('tracker');
        set(trackerIds.map(trackerId => trackerStore(trackerId)));
    }
    loadTrackers();
    return {
        subscribe,
        async addTracker(meta) {
            await (await db).add('tracker', Object.assign(Object.assign({}, meta), { createdAt: new Date().getTime() }));
            update(previousStores => [...previousStores, trackerStore(meta.trackerId)]);
        },
        async addOrUpdateTracker(id, meta) {
            await (await db).put('tracker', meta);
            await loadTrackers();
        },
    };
}();
const trackerStores = new Map();
export function trackerStore(id) {
    if (trackerStores.has(id)) {
        return trackerStores.get(id);
    }
    const { subscribe, set, update } = writable(null);
    db.then(async (db) => {
        const meta = await db.get('tracker', id);
        const entries = (await db.getAllFromIndex('entry', 'by-trackerId', id)).reverse();
        set({ id, meta, entries });
    });
    const store = {
        trackerId: id,
        subscribe,
        async setMeta(meta) {
            await (await db).put('tracker', meta);
            update(original => (Object.assign(Object.assign({}, original), { meta })));
        },
        async addEntry(entry) {
            if (entry.trackerId !== id)
                throw Error(`Tried adding entry of tracker ${entry.trackerId} to tracker ${id}`);
            await (await db).add('entry', entry);
            const entries = (await (await db).getAllFromIndex('entry', 'by-trackerId', id)).reverse();
            update(original => (Object.assign(Object.assign({}, original), { entries })));
        },
        async addOrUpdateEntry(entry) {
            if (entry.trackerId !== id)
                throw Error(`Tried adding entry of tracker ${entry.trackerId} to tracker ${id}`);
            await (await db).put('entry', entry);
            const entries = (await (await db).getAllFromIndex('entry', 'by-trackerId', id)).reverse();
            update(original => (Object.assign(Object.assign({}, original), { entries })));
        },
    };
    trackerStores.set(id, store);
    return store;
}
